export const api_url = 'https://api.logistics.albanyproducts.co.uk/';
export const holidays = ['2019-08-26', '2019-12-25', '2019-12-26', '2020-01-01', '2020-04-10', '2020-04-13', '2020-05-08', '2020-05-25', '2020-08-31', '2020-12-25', '2020-12-28'];
export const timezone = "Europe/London";
export const debug = false;
export const part_load_threshold = 13;